import { useState, useEffect } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { ApplicationState } from '../../../../../store';
import { saveVisaPrepForm } from '../../../../../store/student/actions';
import { createUpdateVPIFieldAction } from '../../../../../store/student/visaPrepForm/actions';
import QuestionPage from '../../../../templates/question';
import { VQ } from '../../../../../store/student/types';
import { TextareaWithConfirm, TitleAndEditButton } from 'shared-components';

import { Pages } from '../../../../../store/student/visaPrepForm/types';
import { getPageStatus } from './utils';
import { useNavigate } from 'react-router-dom';
import { useCustomNavigate } from '../../../../../hooks/useCustomNavigate';

const VisaPrepFormAddHistoryPage1 = (props: any) => {
  // dispatch actions
  const dispatch = useDispatch();
  const onNext = () => {
    dispatch(saveVisaPrepForm(Pages.PAGE2_1));
  };
  const onChange = (fieldName: string, value: any, refValue?: any) =>
    dispatch(createUpdateVPIFieldAction(fieldName, value, refValue));

  const navigate = useNavigate();
  const onBackToTaskList = () => navigate(-1);
  const { navigateTo } = useCustomNavigate();
  const onEdit = () => navigateTo(`${props.params.offerId}/history/step-3`);

  // state props from store
  const nonHomeCountryApplicationDesc = useSelector(
    ({ student }: ApplicationState) => student.visa.nonHomeCountryApplicationDesc,
    shallowEqual,
  );

  // constants
  const currentStep = 1;
  const steps = 8;

  // component state
  const [complete, setComplete] = useState(false);

  useEffect(() => {
    const { complete: newComplete } = getPageStatus({
      nonHomeCountryApplicationDesc,
    });
    if (newComplete !== complete) {
      setComplete(newComplete);
    }
  }, [complete, nonHomeCountryApplicationDesc]);

  const onNonHomeCountryAppDescChange = (evt: any) => {
    onChange(VQ.NON_HOME_COUNTRY_APP_DESC, evt.currentTarget.value);
  };

  return (
    <QuestionPage
      complete={complete}
      currentStep={currentStep}
      steps={steps}
      onNext={onNext}
      onBackToTaskList={onBackToTaskList}
      section={'Additional History'}
    >
      <TitleAndEditButton title="You indicated that you are not applying from your home country" onClick={onEdit} />

      <TextareaWithConfirm
        key={VQ.NON_HOME_COUNTRY_APP_DESC}
        id={VQ.NON_HOME_COUNTRY_APP_DESC}
        value={nonHomeCountryApplicationDesc}
        label={
          'Please explain your visa/immigration status for the country you are applying from, and the expiry date of any visas you hold for this country'
        }
        onChange={onNonHomeCountryAppDescChange}
      />
    </QuestionPage>
  );
};
export default VisaPrepFormAddHistoryPage1;
